<svg
	width="24px"
	height="24px"
	viewBox="0 0 24 24"
	version="1.1"
	xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink"
>
	<defs>
		<path
			d="M12,0.999999954 C18.1,0.999999954 23,5.89999997 23,12 C23,18.1 18.1,23 12,23 C5.89999997,23 0.999999954,18.1 0.999999954,12 C0.999999954,5.89999997 5.94999997,0.999999954 12,0.999999954 Z M12,2.49999996 C6.74999998,2.49999996 2.49999996,6.74999998 2.49999996,12 C2.49999996,17.25 6.74999998,21.5 12,21.5 C17.25,21.5 21.5,17.25 21.5,12 C21.5,6.74999998 17.25,2.49999996 12,2.49999996 Z M12,3.99999997 C12.4,3.99999997 12.75,4.29999997 12.75,4.74999997 L12.75,4.74999997 L12.75,11.55 L17.15,13.95 C17.55,14.15 17.65,14.65 17.45,15 C17.3,15.25 17.05,15.4 16.8,15.4 C16.7,15.4 16.55,15.35 16.45,15.3 L16.45,15.3 L11.25,12.45 L11.25,4.74999997 C11.25,4.34999997 11.6,3.99999997 12,3.99999997 Z"
			id="path-cf1da9a3-fc12-11ea-8540-cbdab8b6ea40"
		></path>
	</defs>
	<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
		<mask id="mask-2" fill="white">
			<use xlink:href="#path-cf1da9a3-fc12-11ea-8540-cbdab8b6ea40"></use>
		</mask>
		<use fill="currentColor" xlink:href="#path-cf1da9a3-fc12-11ea-8540-cbdab8b6ea40"></use>
	</g>
</svg>
